<template>
  <main class="organism-ticket-detail">
    <section name="header">
      <div class="header__container">
        <label class="header__text--topic">Ticket Detail</label>
        <b-badge
          pill
          :variant="badgeVariant(status)"
          class="badge--style tag--space"
          >{{ badgeStatus(status) }}
        </b-badge>
      </div>
    </section>

    <!-- Customer Start-->
    <section name="customer">
      <div class="customer__container">
        <div class="customer__idc w-100 d-flex">
          <label class="text--header">{{ contractIdLabel }}</label>
          <label class="text--body font-weight-bold">
            {{ customer.idcId }}
          </label>
        </div>
        <div class="customer__name w-100 d-flex">
          <label class="text--header">Ticket ID</label>
          <label class="text--body">{{ customer.ticketId }}</label>
        </div>
        <div class="customer__name w-100 d-flex">
          <label class="text--header">Customer Name</label>
          <label class="text--body">{{ customer.name }}</label>
        </div>
        <div class="customer__email w-100 d-flex">
          <label class="text--header">Email Addresses</label>
          <label class="text--body">{{ customer.email }}</label>
        </div>
        <div class="customer__phone w-100 d-flex">
          <label class="text--header">Phone Numbers</label>
          <label class="text--body">{{ customer.phone }}</label>
        </div>
        <div class="customer__site w-100 d-flex">
          <label class="text--header">Site</label>
          <label class="text--body">{{ customer.site }}</label>
        </div>
        <div class="customer__location w-100 d-flex">
          <label class="text--header">Location</label>
          <span class="text--body text-show-new-line">{{
            customer.locations
          }}</span>
        </div>
      </div>
    </section>
    <!-- customer End-->

    <!-- Ticket & TicketDetail Start-->
    <section name="ticket-ticket-detail">
      <hr />
      <div class="ticket-ticket-detail__container">
        <!-- Ticket Start-->
        <div class="ticket__container">
          <div class="ticket__topic d-flex">
            <label class="text--header">Topic</label>
            <label class="text--body">{{ ticket.topic.name }}</label>
          </div>
          <div class="ticket__subject w-100 d-flex">
            <label class="text--header">Topic Subject</label>
            <label class="text--body">{{ ticket.subject }}</label>
          </div>
          <div class="ticket__detail w-100 d-flex">
            <label class="text--header">Detail</label>
            <div class="text--body">
              <span>{{ ticket.detail }}</span>
            </div>
          </div>
        </div>
        <!-- Ticket End-->

        <!-- TicketDetail Start-->
        <div class="ticket-detail__container">
          <div class="ticket-detail__department w-100 d-flex">
            <label class="text--header">Department</label>
            <label class="text--body">{{
              ticketDetail.department || "-"
            }}</label>
          </div>
          <div class="ticket-detail__source w-100 d-flex">
            <label class="text--header">Source</label>
            <label class="text--body">{{ ticketDetail.source.name }}</label>
          </div>
          <div class="ticket-detail__created-by w-100 d-flex">
            <label class="text--header">Created by</label>
            <label class="text--body">{{ ticketDetail.createdBy }}</label>
          </div>
          <div class="ticket-detail__updated-by w-100 d-flex">
            <label class="text--header">Updated by</label>
            <label class="text--body">{{ ticketDetail.updatedBy }}</label>
          </div>
        </div>
      </div>
    </section>

    <section name="attachment-and-button">
      <div class="ticket__attachments w-100 d-md-flex align-items-center">
        <label class="text--header d-none d-md-block">Attachment</label>
        <div class="attachment-width">
          <atom-file-attachment-input
            v-if="status !== 'CLOSED'"
            id="ticketExternalDetailAttachment"
            title="Attachments (Max. 25Mb)"
            :forceClearFileValue="forceClearFileValue"
            :isDisable="status === 'CLOSED'"
            @onUpdateFile="onUpdateTicketAttachment"
          ></atom-file-attachment-input>
          <atom-file-attachment-list
            v-if="attachmentFileList.length"
            :class="{ 'mt-1': status !== 'CLOSED' }"
            :isDeletable="status !== 'CLOSED'"
            :attachmentList="attachmentFileList"
            @onRequestDeleteAttachment="onRequestDeleteAttachment"
          ></atom-file-attachment-list>
          <label
            v-else-if="!attachmentFileList.length && !targetAttachment.length"
            class="text--body"
            >-</label
          >
        </div>
      </div>

      <div
        v-if="targetAttachment.length"
        class="button__height d-flex justify-content-end mt-1"
      >
        <div class="button__save">
          <atom-button
            buttonId="button__save-edit-ticket"
            @click="clickSaveChanges"
            >Save Changes</atom-button
          >
        </div>
        <div class="button__cancel">
          <atom-button
            buttonId="button__cancel-edit-ticket"
            buttonStyle="border"
            buttonColor="secondary"
            @click="clickCancel"
            >Cancel</atom-button
          >
        </div>
      </div>
    </section>
    <!-- Ticket & TicketDetail End-->

    <!-- Ticket Detail Start-->
    <section name="ticket-detail">
      <hr />
      <div class="ticket-detail__container">
        <label class="ticket-detail__header">TICKET DETAILS</label>

        <div class="duration__container d-flex">
          <div class="duration__created">
            <label class="duration__text--header">Created Date</label>
            <label class="duration__text--body w-100">{{
              ticketTimestamp.createdAt
            }}</label>
          </div>
          <div class="duration__closed">
            <label class="duration__text--header">Closed Date</label>
            <label class="duration__text--body w-100">{{
              ticketTimestamp.closedAt
            }}</label>
          </div>
          <div class="duration__duration">
            <label class="duration__text--header">Duration</label>
            <label class="duration__text--body w-100">{{
              ticketTimestamp.closedAt ? ticketTimestamp.duration : "-"
            }}</label>
          </div>
        </div>

        <molecule-external-thread
          :status="status"
          :activityCommunityList="activityCommunityList"
          @onClickAddTicketActivity="onClickAddTicketActivity"
          @onRequestDeleteAttachment="onRequestDeleteAttachmentFromThread"
        ></molecule-external-thread>
      </div>
    </section>
    <!-- Ticket Detail End-->

    <molecule-modal-dialog
      modalId="ticket-detail__confirm-edit-ticket"
      :isTextCenter="true"
      :textTitle="`Do you want to save\n“${ticketId}” ?`"
      buttonTextLeft="Confirm"
      @clickButtonLeft="clickConfirmSaveChanges"
    ></molecule-modal-dialog>
  </main>
</template>

<script>
import { BBadge } from "bootstrap-vue"
import MoleculeExternalThread from "@/components/molecules/portal/ticket/MoleculeExternalThread.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import AtomFileAttachmentInput from "@/components/atoms/AtomFileAttachmentInput.vue"
import AtomFileAttachmentList from "@/components/atoms/AtomFileAttachmentList.vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import mixins from "@/mixins"

export default {
  name: "OrganismTicketDetail",
  components: {
    BBadge,
    MoleculeExternalThread,
    MoleculeModalDialog,
    AtomButton,
    AtomFileAttachmentList,
    AtomFileAttachmentInput,
  },
  mixins: [mixins],
  props: {
    status: {
      type: String,
      required: true,
    },
    customer: {
      type: Object,
      required: false,
      default: () => {},
    },
    ticketId: {
      type: String,
      required: false,
      default: "",
    },
    ticket: {
      type: Object,
      required: false,
      default: () => {},
    },
    ticketDetail: {
      type: Object,
      required: false,
      default: () => {},
    },

    // ticket detail
    ticketTimestamp: {
      type: Object,
      required: true,
    },
    activityCommunityList: {
      type: Array,
      required: true,
    },

    pageForceClearFileValue: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  emits: [
    "onClickDownloadFile",
    "onClickSaveEditTicket",
    "onClickAddTicketActivity",
  ],

  data() {
    return {
      attachmentFileList: [],
      targetAttachment: [],
      organismForceClearFileValue: 0,
      forceClearFileValue: 0,
      modalId: "",
    }
  },

  watch: {
    pageForceClearFileValue() {
      this.forceClearFileValue += 1
    },

    organismForceClearFileValue() {
      this.forceClearFileValue += 1
    },

    ticket: {
      deep: true,
      immediate: true,
      handler() {
        if (this.ticket.attachments) {
          this.attachmentFileList = this.ticket.attachments.map(
            (attachment) => {
              return {
                id: attachment.attachmentId,
                name: attachment.fileName,
                originalFileName: attachment.originalFileName,
                path: attachment.attachmentPath,
                createdBy: attachment.createdBy,
              }
            }
          )
        } else {
          this.attachmentFileList = []
        }
      },
    },
  },

  methods: {
    // download file
    onClickDownloadFile() {
      this.$emit("onClickDownloadFile", this.ticket.attachments)
    },

    onClickAddTicketActivity(thread) {
      const addActivity = {
        ticketId: this.ticketId,
        threadMessage: thread.message,
      }

      const attachment = thread.attachment

      this.$emit("onClickAddTicketActivity", addActivity, attachment)
    },

    badgeVariant(status) {
      if (status === "OPENED") return "light-primary"
      else if (status === "IN_PROGRESS") return "light-warning"
      else return "light-secondary"
    },
    badgeStatus(status) {
      if (status === "OPENED") return "Opened"
      else if (status === "IN_PROGRESS") return "In Progress"
      else return "Closed"
    },

    onUpdateTicketAttachment(fileList) {
      this.targetAttachment = fileList
    },

    onRequestDeleteAttachment(file) {
      this.$emit("onRequestDeleteAttachment", file)
    },

    clickSaveChanges() {
      this.modalId = "ticket-detail__confirm-edit-ticket"
      this.openModal(this.modalId)
    },

    clickCancel() {
      this.organismForceClearFileValue++
    },

    clickConfirmSaveChanges() {
      this.$emit(
        "onRequestUploadAttachment",
        this.ticketId,
        this.targetAttachment
      )
      this.closeModal()
    },

    // modal
    openModal(id) {
      this.modalId = id
      this.$bvModal.show(this.modalId)
    },

    // close modal
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
    },

    onRequestDeleteAttachmentFromThread(file, thread) {
      this.$emit("onRequestDeleteAttachmentFromThread", file, thread)
    },
  },
}
</script>

<style lang="scss" scoped>
.organism-ticket-detail {
  width: 100%;
  height: 100%;
  background: white;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
}

section[name="header"] {
  .header__container {
    padding: 21px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .header__text--topic {
    margin: 0;
    font-weight: 500;
    font-size: 18px;
  }
}

section[name="customer"] {
  .customer__container {
    padding: 0 21px 21px 21px;
  }

  .customer__name,
  .customer__email,
  .customer__phone,
  .customer__site,
  .customer__location {
    margin: 1rem 0 0 0;
  }
}

section[name="ticket-ticket-detail"] {
  .ticket-ticket-detail__container {
    padding: 21px 21px 16px 21px;
    position: relative;
  }

  .ticket-ticket-detail__button-edit {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0 21px 0 10px;
  }

  .ticket__container,
  .ticket-detail__container {
    width: 100%;
  }

  .ticket__topic {
    width: calc(100% - 50px);
  }

  .ticket__subject,
  .ticket__detail,
  .ticket__attachments,
  .ticket__priority,
  .ticket-detail__department,
  .ticket-detail__source,
  .ticket-detail__created-by,
  .ticket-detail__updated-by {
    display: block;
    margin: 1rem 0 0 0;

    overflow-wrap: break-word;
    word-break: break-word;
  }

  @media screen and (min-width: 1200px) {
    .ticket-ticket-detail__container {
      display: flex;
    }

    .ticket__container {
      width: 50%;
    }

    .ticket-detail__container {
      width: calc(50% - 50px);
    }

    .ticket__container {
      padding: 0 1rem 0 0;
    }

    .ticket-detail__container {
      padding: 0 0 0 1rem;
    }

    .ticket-detail__department {
      margin: 0;
    }
  }
}

section[name="ticket-detail"] {
  .ticket-detail__container {
    padding: 21px 21px 21px 21px;
  }

  .ticket-detail__header {
    margin: 0;
    color: #b9b9c3;
    font-weight: 500;
    font-size: 12px;
  }

  .duration__container {
    width: 100%;
    margin: 1rem 0 30px 0;
  }

  .duration__created,
  .duration__closed,
  .duration__duration {
    width: calc(100% / 3);
    display: flex;
    flex-direction: column;
  }

  .duration__created {
    padding: 0 1rem 0 0;
  }
  .duration__closed {
    padding: 0 0.5rem 0 0.5rem;
  }
  .duration__duration {
    padding: 0 0 0 1rem;
  }

  .duration__text--header {
    margin: 0;
    color: #5e5873;
    font-size: 12px;
  }

  .duration__text--body {
    width: 0;
    color: #5e5873;
    font-weight: 500;
    font-size: 12px;
  }

  @media screen and (min-width: 1200px) {
    .duration__container {
      width: 650px;
    }
  }
}

section[name="attachment-and-button"] {
  padding: 0 21px;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid #ebe9f1;
}

.text--header {
  margin: 0 1rem 0 0;
  width: calc(100px - 1rem);
  color: #6e6b7b;
  font-size: 14px;
  font-weight: 600;
}

.text--body {
  margin: 0;
  width: calc(100% - 100px);
  color: #5e5873;
  font-size: 14px;
  white-space: pre-wrap;
}

.text--file {
  margin: 0;
  width: calc(100% - 100px);
  color: #7367f0;
  font-size: 14px;
  text-decoration-line: underline;
  cursor: pointer;
}

.text-width {
  width: calc(100% - 100px);
}

.input-container {
  width: 100%;
}

.input-container-small {
  width: 75px;
}

.button__height {
  min-height: 38px;
}

.button__container {
  position: absolute;
  bottom: 21px;
  right: 21px;
  display: flex;
  justify-content: flex-end;
}

.button__cancel {
  margin: 0 0 0 16px;
}

.attachment-width {
  width: 100%;
}

@media screen and (min-width: 768px) {
  .text--header {
    width: 170px;
  }

  .text--body,
  .text--file {
    width: calc(100% - 170px);
  }

  .text-width {
    width: calc(100% - 170px);
  }

  .input-container {
    width: 325px;
  }

  .attachment-width {
    width: 80%;
  }
}

@media screen and (min-width: 992px) {
}

@media screen and (min-width: 1200px) {
}
</style>
